<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-calendar
            </v-icon>
          </v-btn>
        </template>
        <span>Forecast Prorated Days</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="entitlement.employee.person.name"
      :text="entitlement.leave_type.name"
      class="mb-0"
    > 
      <template v-if="!loading">
        <v-container>
          <v-row>
            <v-col cols="3">
              <v-menu
                v-model="lastDayDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="lastDayDate"
                    v-validate="'required'"
                    data-vv-name="lastDayDate"
                    data-vv-as="last day date"
                    label="Last day date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="lastDayDate"
                  no-title
                  :min="entitlement.employee.joined_date && entitlement.employee.joined_date > this.$moment().startOf('year').format('YYYY-MM-DD') ? entitlement.employee.joined_date : this.$moment().startOf('year').format('YYYY-MM-DD')"
                  :max="entitlement.employee.last_working_date && entitlement.employee.last_working_date < this.$moment().endOf('year').format('YYYY-MM-DD') ? entitlement.employee.last_working_date : this.$moment().endOf('year').format('YYYY-MM-DD')"
                  @input="lastDayDateMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              class="mt-3"
              cols="3"
            >
              <v-btn
                :disabled="!lastDayDate"
                color="hrissecondary"
                :loading="loading"
                class="white--text px-10"
                @click="submitForm"
              >
                Calculate
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col class="font-weight-bold">
                  Joined Date:
                </v-col>
                <v-col class="font-weight-bold">
                  {{ employeeInfo ? employeeInfo.joined_date : '' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="font-weight-bold"
                >
                  Total Prorated Days:
                </v-col>
                <v-col
                  class="font-weight-bold green--text"
                  style="font-size:18px"
                >
                  {{ employeeInfo && employeeInfo.total_prorated_days ? employeeInfo.total_prorated_days.toFixed(2) : '' }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="leaveInfo">
            <v-col>
              <v-data-table
                :headers="headers"
                :items="leaveInfo"
                :hide-default-footer="true"
              />
            </v-col>
          </v-row>
          <v-row v-show="false">
            <v-col
              class="mt-3"
              cols="9"
            />
            <v-col
              class="mt-3"
              cols="3"
            >
              <v-btn
                :disabled="!employeeInfo"
                color="hrissecondary"
                class="white--text"
                :loading="loading"
                @click="updateForm"
              >
                Update
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      entitlement: {
        type: Object,
        default: null,
      },    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        lastDayDate: null,
        lastDayDateMenu: false,
        leaveInfo: null,
        otherInfo: null,
        employeeInfo: null,
        headers: [
          {
            text: 'Start Date',
            value: 'startDate',
            align: 'center',
            width: '23%',
          },
          {
            text: 'End Date',
            value: 'endDate',
            align: 'center',
            width: '23%',
          },
          {
            text: 'Service Days',
            value: 'serviceDays',
            align: 'right',
            width: '17%',
          },
          {
            text: 'Entitled Days',
            value: 'entitledDays',
            align: 'right',
            width: '17%',
          },
          {
            text: 'Prorated Days',
            value: 'proratedDays',
            align: 'right',
            width: '20%',
          },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.leaveInfo = null
          this.employeeInfo = null
          this.otherInfo = null
          this.lastDayDate = null
        }
      },
    },
    methods: {
      submitForm () {
        this.$api.leaveForecast().forecastProratedDays(this.entitlement.id, this.prepareFormData())
          .then(response => {
            this.leaveInfo = response.data.leaveInfo
            this.employeeInfo = response.data.employeeInfo
            this.otherInfo = response.data.otherInfo
          })
          .catch(() => {})
          .then(() => {
            if (this.otherInfo) {
              this.$snack({ color: 'error', message: this.otherInfo })
            }
            this.progressing = false
          })
      },
      prepareFormData () {
        return {
          last_day_date: this.lastDayDate,
        }
      },
      updateForm () {
        this.$api.leaveForecast().updateForecastProratedDays(this.entitlement.id, { total_prorated_days_before_rounding: this.employeeInfo.total_prorated_days_before_rounding.toFixed(3), total_prorated_days: this.employeeInfo.total_prorated_days.toFixed(2) })
          .then(response => {
            this.progressing = false
            this.dialog = false
          })
          .catch(() => {})
      },
    },
  }
</script>
